export default __webpack_public_path__ + "static/media/whatsapp.7bb3f4d8.svg";